// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__e62L7","icon":"Footer_icon__zjBNg"};